import { gql } from '@apollo/client';
import { EntityNoteFragment } from '../fragments/EntityNoteFragment';
/**
 * @const CreateEntityNoteMutation
 * @since 1.0.0
 */
export const CreateEntityNoteMutation = gql `
  mutation CreateEntityNoteMutation($input: CreateEntityNoteInput!) {
    createEntityNote(input: $input) {
      ...EntityNoteFragment
    }
  }

  ${EntityNoteFragment}
`;
